<template>
    <div class="pageBox">
        <div class="frame">
            <div class="box nav">
                <span>当前位置：</span>
                <router-link to="/">首页</router-link>
                &nbsp;&nbsp;>&nbsp;&nbsp;
                <router-link
                    :to="{name:'ServeList',params:{stId:categoryId1}}">{{ categoryName1 }}
                </router-link>
                <div v-if="categoryId2>0">
                    <router-link
                        :to="{name:'ServeList',params:{stId:categoryId2}}">
                        &nbsp;&nbsp;>&nbsp;&nbsp;{{ categoryName2 }}
                    </router-link>
                </div>
                <span v-if="categoryId3>0">&nbsp;&nbsp;>&nbsp;&nbsp;{{ categoryName3 }}</span>
            </div>
        </div>
        <div class="cateRow" v-if="category.length>0">
            <div class="cateBox">
                <div class="rowTitle">服务目录：</div>
                <div class="categoryBox">
                    <el-checkbox-group v-model="checkedCate" @change="handleCheckedCate1Change">
                        <el-checkbox v-for="(item,index) in category" :key="index" :label="item.id">
                            {{ item.serivceTypeName }}
                        </el-checkbox>
                    </el-checkbox-group>
                </div>
            </div>
        </div>
        <div class="ListBox" v-if="serve.length>0">
            <div class="ListFrame">
                <router-link :to="{name:'ServeDetail',params:{sId:item.id}}"
                             class="item"
                             v-for="(item,index) in serve"
                             :key="index">
                    <div class="imgBox">
                        <img :src="item.serviceImg" :alt="item.title">
                    </div>
                    <div class="name">{{ item.title }}</div>
                    <div class="info">{{ item.subTitle }}</div>
                </router-link>
            </div>
            <div class="pagination">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pageIndex"
                    :page-sizes="[8, 12, 16, 20]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalCount">
                </el-pagination>
            </div>
        </div>
        <div v-else class="noData">此服务下暂无数据！</div>
    </div>
</template>

<script>
export default {
    name: "serveList",
    data() {
        return {
            //服务类型列表
            category: [],
            pageSize: 8,
            pageIndex: 1,
            totalCount: 0,
            //服务列表
            serve: [],
            //服务类型选中列表
            checkedCate: [],
            categoryId1: 0,
            categoryName1: '',
            categoryId2: 0,
            categoryName2: '',
            categoryId3: 0,
            categoryName3: '',
        }
    },
    mounted() {
        this.$store.commit('setNav', 2)
        this.getServeTypeList(this.$route.params.stId)
    },
    watch: {
        '$route.params.stId'() {
            this.checkedCate = []
            this.getServeTypeList(this.$route.params.stId)
        },
    },
    methods: {
        handleSizeChange(val) {
            this.pageSize = val
            this.getServeTypeList(this.$route.params.stId)
        },
        handleCurrentChange(val) {
            this.pageIndex = val
            this.getServeTypeList(this.$route.params.stId)
        },
        handleCheckedCate1Change(value) {
            if (value.length > 1) {
                this.checkedCate = []
                this.checkedCate.push(value[1])
            }
            this.$router.push({name: 'ServeList', params: {stId: this.checkedCate[0]}});
        },

        /**
         * 获取服务类型列表
         */
        getServeTypeList(id) {
            this.$get('/V1/ServiceType/GetAllServiceTypes', {})
                .then((res) => {
                    // console.log('type', res)
                    if (res.success) {
                        this.getServeList(id)
                        let tmp = res.response
                        for (let i = 0; i < tmp.length; i++) {
                            if (tmp[i].id == id) {//一级
                                this.categoryId1 = id
                                this.categoryName1 = tmp[i].serivceTypeName
                                if (tmp[i].children != null) {
                                    this.category = tmp[i].children
                                } else {
                                    this.category = []
                                }
                                this.categoryId2 = 0
                                this.categoryId3 = 0
                                this.categoryName2 = ''
                                this.categoryName3 = ''
                            } else {
                                let tmp2 = tmp[i].children
                                if (tmp2 != null) {
                                    for (let j = 0; j < tmp2.length; j++) {
                                        if (tmp2[j].id == id) {//二级
                                            this.categoryId2 = id
                                            this.categoryName2 = tmp2[j].serivceTypeName
                                            if (tmp2[j].children != null) {
                                                this.category = tmp2[j].children
                                            } else {
                                                this.category = []
                                            }
                                            for (let m = 0; m < tmp.length; m++) {
                                                if (tmp[m].id == tmp2[j].parentId) {//一级
                                                    this.categoryId1 = tmp[m].id
                                                    this.categoryName1 = tmp[m].serivceTypeName
                                                }
                                            }
                                            this.categoryId3 = 0
                                            this.categoryName3 = ''
                                        } else {
                                            let tmp3 = tmp2[j].children
                                            if (tmp3 != null) {
                                                for (let k = 0; k < tmp3.length; k++) {
                                                    if (tmp3[k].id == id) {//三级
                                                        this.category = []
                                                        this.categoryId3 = id
                                                        this.categoryName3 = tmp3[k].serivceTypeName
                                                        let cate1
                                                        for (let n = 0; n < tmp2.length; n++) {
                                                            if (tmp2[n].id == tmp3[k].parentId) {//二级
                                                                this.categoryId2 = tmp2[n].id
                                                                this.categoryName2 = tmp2[n].serivceTypeName
                                                                cate1 = tmp2[n].parentId
                                                            }
                                                        }
                                                        for (let p = 0; p < tmp.length; p++) {
                                                            if (tmp[p].id == cate1) {//一级
                                                                this.categoryId1 = tmp[p].id
                                                                this.categoryName1 = tmp[p].serivceTypeName
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        //更新title
                        let title = '全部服务'
                        if (this.categoryName3 != '') {
                            title = this.categoryName3
                        } else if (this.categoryName2 != '') {
                            title = this.categoryName2
                        } else if (this.categoryName1 != '') {
                            title = this.categoryName1
                        }
                        document.title = title + this.$suffix
                    } else {
                        this.$message.error("网络错误，请重试");
                    }
                })
                .catch(() => {
                    this.$message.error("网络错误，请重试");
                })
        },

        /**
         * 获取服务列表
         */
        getServeList(id) {
            this.$get('/V1/ServiceType/GetServiceTypeListDetail',
                {
                    "pageSize": this.pageSize,
                    "pageIndex": this.pageIndex,
                    "serviceTypeId": id,
                })
                .then((res) => {
                    // console.log('list', res)
                    if (res.success) {
                        this.serve = res.response.details
                        this.totalCount = res.response.total
                    } else {
                        this.$message.error("网络错误，请重试");
                    }
                })
                .catch(() => {
                    this.$message.error("网络错误，请重试");
                })
        }
    }
}
</script>

<style scoped lang="less">
::v-deep .el-checkbox-group label {
    margin-bottom: 10px;
    font-size: 16px!important;
}

::v-deep .el-checkbox__label{
    font-size: 16px!important;
}

.pageBox {
    display: flex;
    flex-direction: column;

    .frame {
        width: 100%;
        background-color: #f0f0f0;

        .box {
            width: 1210px;
            margin: 0 auto;
        }

        .nav {
            display: flex;
            flex-direction: row;
            align-items: center;
            color: #666666;
            font-size: 16px;
            height: 40px;
            line-height: 40px;

            a {
                color: #666;
            }
        }
    }

    .cateRow {
        background-color: white;
        border-top: 1px solid #f9f9f9;

        .cateBox {
            width: 1210px;
            margin: 0 auto;
            display: flex;
            flex-direction: row;
            border-bottom: 1px dashed #eeeeee;
            padding: 20px 0px;


            .rowTitle {
                width: 100px;
                min-width: 100px;
                font-size: 16px;
                font-weight: bold;
            }

            .categoryBox {
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;
                font-size: 15px;
            }

        }
    }

    .noData {
        width: 1210px;
        margin: auto auto;
        color: red;
    }

    .ListBox {
        display: flex;
        flex-direction: column;
        background-color: #f9f9f9;
        padding: 20px 0px;

        .ListFrame {
            width: 1210px;
            margin: 0 auto 20px;
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            min-height: 400px;

            .item {
                display: flex;
                flex-direction: column;
                align-items: center;
                padding: 20px;
                width: 249px;
                height: 191px;
                background-color: white;
                margin-top: 15px;
                margin-bottom: 10px;
                margin-right: 18px;
                border-radius: 5px;

                .imgBox {
                    width: 250px;
                    height: 125px;
                    overflow: hidden;
                    border: 1px solid #cccccc;
                    margin-bottom: 10px;

                    img {
                        width: 100%;
                        height: 100%;
                    }
                }

                .name {
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    color: #1f2d5c;
                    font-size: 18px;
                    max-width: 100%;
                    margin-bottom: 10px;
                    height: 24px;
                }

                .info {
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    color: #999;
                    font-size: 15px;
                    max-width: 100%;
                    height: 20px;
                }
            }

            .item:nth-child(4n) {
                margin-right: 0;
            }

            .item:hover {
                box-shadow: 0px 0px 8px 0px #d0d0d0;
                margin-top: 10px;
                margin-bottom: 14px;
                transition: .4s;
            }
        }

        .pagination {
            width: 1210px;
            margin: 0 auto;
        }
    }
}

</style>
